export default "__VITE_ASSET__kwowCvgo__"